import { render, staticRenderFns } from "./FinishedContest.vue?vue&type=template&id=77fffa26"
import script from "./FinishedContest.vue?vue&type=script&lang=js"
export * from "./FinishedContest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports